module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('h1', {
    staticClass: "h1a",
    attrs: {
      "id": "intro"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "grayu"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('h1', {
    staticClass: "h1b"
  }, [_vm._v("Defining the Inclusive Leader")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT DOES AN INCLUSIVE LEADER LOOK LIKE")]), _vm._v("? There’s plenty of opinion in the public square about this, as well as many inspiring stories. But we wanted to start with the science. What do the 3 million leadership assessments in our Korn Ferry database tell us about the unique elements of inclusive leaders? Here, we lay out the scientific approach that led to our traits- and competencies-based Inclusive Leader model. We also touch on the role of life experiences in the inclusive leader’s formation and development.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let’s look at the compelling ways that organizations use D&I to unleash the power of all of us.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("CONTEXTUALIZING INCLUSIVE LEADERSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First things first. Let’s explain what we mean by "), _c('em', [_vm._v("diversity, inclusion,")]), _vm._v(" and "), _c('em', [_vm._v("equity")]), _vm._v(". Diversity is about getting a mix of different people in the door, inclusion is about ensuring that mix is working well, and equity is fulfilling the promise that they all have equal access, opportunity, support, and rewards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While headlines deluge us with the disturbing news that our societies are increasingly polarizing, a massive diversity, inclusion, and equity movement is afoot within corporations and nonprofit organizations. This countertrend to polarization is fueled by both altruism and self-interest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "2",
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("On the altruistic side, many employers in all sectors—including industrials, the consumer sector, financial services, technology, health care, pharmaceuticals, the legal professions, government, nonprofits, and the military—have a genuine concern for ensuring that their talent feels valued, respected, and safe in the midst of divisions. They seek to have equitable organizations where disparities at any level, including access, opportunity, support, and reward, don’t exist. They want to deliver on their promise of equality, that no one will be favored or disfavored on the basis of who they are.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the self-interest side, a tsunami of demographic changes has presented organizations with unprecedented challenges and opportunities. Organizations are desperately trying to figure out the answers to these vexing questions:")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" How do we attract the best talent from talent pools that have never before been tapped?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" How do we ensure that all talent, including women; people of different races, ethnicities, and socioeconomic status; and those with different physical and cognitive abilities, sexual orientations, or personalities, can rise to the fullness of their potential and into the highest levels of leadership?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" How do we ensure that the increased complexity of more diverse workforces does not lead to destructive conflict?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" How do we tap into our organization’s diversity to reach previously unreached consumers and markets?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" How do we optimize diversity for greater innovation and organizational growth?")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This long and comprehensive list of challenges underscores the notion that organizational competitiveness now and long into the future requires us to leverage diversity and inclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hard financial metrics back this up. In a study of one thousand companies across twelve countries, McKinsey & Company found strong associations between diversity and financial performance. Companies in the top quartile for racial and ethnic diversity were 36% more likely to have financial returns above their respective national industry medians, while those in the top quartile for gender diversity were 25% more likely to have financial returns above their medians. Furthermore, inclusive organizations were found to be 70% more likely "), _c('span', {
    attrs: {
      "aria-label": "3",
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("to capture new markets, 75% more likely to see ideas become productized, and 87% more likely to make better decisions, while enjoying 19% higher innovation revenue ("), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_1"
    }
  }, [_vm._v("figure 1")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chinote1",
      "id": "rchinote1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The case is clear: whether for altruistic or self-interested reasons, leaders need to design organizations that equitably meet the needs of all their talent. And this exciting movement toward building tomorrow’s equitable organizations is dependent on a new type of leader: the inclusive leader.")]), _vm._v(" "), _c('p', {
    staticClass: "fimage"
  }, [_c('a', {
    attrs: {
      "id": "fig0_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0003-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('strong', [_vm._v("Figure 1.")]), _vm._v(" Done well, diversity and inclusion maximizes performance of individuals, teams, and organizations. "), _c('em', [_vm._v("Sources:")]), _vm._v(" McKinsey; Boston Consulting Group; Center for Talent Innovation; Erik Larson; Korn Ferry. For exact sourcing see endnote 1 for this chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The inclusive leader is collaborative and facilitative rather than command and control. They are transparent rather than operating "), _c('span', {
    attrs: {
      "aria-label": "4",
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("within the shadows of closed doors. They are culturally agile rather than anchored in their own worldview. They are able to fully embrace and leverage the vast diversity of today’s workforces. They can create a safe space, regardless of what is happening externally, where people feel accepted and empowered to give the best of their talents. They unleash the power of all of us.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("INCLUSIVE LEADERSHIP IS NOT JUST ABOUT DIVERSITY AND INCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s set diversity and inclusion aside for a moment and look at the research on the skills that future leaders need. A Korn Ferry study of perceptions of investors on whether leaders in organizations are rising to the challenge of massive disruption (“self-disruptive leaders”) confirmed for us that inclusive leadership is not only the key to more equitable organizations; it is the foundation of broader leadership effectiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not only were investors in companies dissatisfied with what they saw (70% argued that short-term pressures stripped leaders of the ability to push through innovation, digitization, and transformative change), but they also considered current leadership styles to be in urgent need of change. As Dennis Baltzley, Korn Ferry’s Global Leadership Practice leader, summarized the implications of the findings: “If you love consistency, the future will be hard for you.” Those surveyed indicated that this includes the majority of leaders, as two-thirds (67%) of them identified current leadership norms as “not fit for the future.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our self-disruptive leader research also found that if companies are to avoid being swept away by today’s massive changes, leaders must “disrupt” themselves—their thoughts, their values, their actions. The disruption of markets can only be met with a disruption of the current leadership approach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The study identified self-disruptive leaders as exceptionally good at partnering with diverse people across their organization’s internal and external ecosystems and effective at creating the trust that helps establish inclusive environments and unlocks the full power of all the talent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sound familiar?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "5",
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("These inclusive leadership behaviors naturally tumbled out of research that was "), _c('em', [_vm._v("not")]), _vm._v(" about diversity and inclusion but rather was about how to be a successful leader in these tumultuous times. There is a 40% overlap in the traits and competencies required of self-disruptive leaders and of inclusive leaders.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What the study shows is that an inclusive leadership mindset and skills are necessary for effective leadership today and for the future. For the twenty-first-century leader of the future, inclusiveness is the new currency of power, influence, and effectiveness. It is the catalyst for unleashing talent to the fullness of its potential—the power of us all—which in turn provides the jet fuel that companies require to seize unprecedented opportunities and maneuver through daunting challenges. "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_2"
    }
  }, [_vm._v("Figure 2")]), _vm._v(" shows the clear logical connections between business performance and inclusive leadership.")]), _vm._v(" "), _c('p', {
    staticClass: "fimage"
  }, [_c('a', {
    attrs: {
      "id": "fig0_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('strong', [_vm._v("Figure 2.")]), _vm._v(" The business case for inclusive leadership. "), _c('em', [_vm._v("Source")]), _vm._v(": Andrés T. Tapia and Alina Polonskaia, "), _c('em', [_vm._v("The Inclusive Leader White Paper")]), _vm._v(" (Korn Ferry, 2020).")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_c('span', {
    attrs: {
      "aria-label": "6",
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("INCLUSIVE LEADERS AS CHANGE AGENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inclusive leadership allows for more effective leadership across the board while still being change agents in addressing specific diversity and inclusion challenges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inclusive leaders can be effective advocates for diversity, fully embracing the business case as it is laid out in "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_2"
    }
  }, [_vm._v("figure 2")]), _vm._v(". They can champion initiatives that make inclusion an organizational priority by ensuring they are addressing both behavioral and structural inclusion, a distinction to which we devote a full chapter in "), _c('span', {
    attrs: {
      "href": "#/xhtml/part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part 3")]), _vm._v(". They can help to identify the root causes of the barriers to retaining and promoting underrepresented employees. They can demand diverse slates of candidates, hold leaders accountable for increasing the pipeline of underrepresented talent, elevate the visibility of affinity groups, and act as role models and advocates for the programmatic and structural changes needed to create an equitable organization.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In our survey of talent management, human resources (HR), and diversity and inclusion experts, there was near consensus on the positive impact inclusive leaders have on their talent, including enabling them to feel free to bring their authentic selves to work, providing them with a sense of empowerment, and reassuring them that there is fairness and that they will be challenged with stretch opportunities (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("appendix B")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#tabAppb_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("table B-1")]), _vm._v("). Respondents also were in agreement about the impact of inclusive leaders on their organizations, such as fostering greater innovation, marketplace growth, and inclusive management practices plus encouraging the organization’s embrace of diversity as a vital part of an economic business case (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("appendix B")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#tabAppb_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("table B-2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For all the upside, however, there still is a large gap between the embracing of diversity and inclusion, and its promise of better business performance, and the actual ability to lead inclusively toward these organizational outcomes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Organizations do not become more diverse and inclusive automatically. An intent to be more diverse doesn’t necessarily lead to increased diversity. Furthermore, greater diversity in and of itself doesn’t necessarily lead to better business results. Inclusive leadership is the necessary bridge to both greater diversity and the enhanced business performance that greater diversity promises. And being an effective inclusive leader requires specific skills, mindsets, experiences, "), _c('span', {
    attrs: {
      "aria-label": "7",
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and self-knowledge. Fortunately, these attributes can be defined, measured, assessed, coached, and developed—which takes us to what we have learned, through science and fieldwork, about what is required to be an inclusive leader.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("WHY GREATER DIVERSITY DOES NOT AUTOMATICALLY LEAD TO BETTER RESULTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leaders in general have not yet been able to fully achieve the promise that greater diversity is good for the organization. A study by Nancy J. Adler demonstrated that while diverse teams do indeed outperform and out-innovate homogeneous teams, they also can be significantly less effective (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_3"
    }
  }, [_vm._v("figure 3")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chinote2",
      "id": "rchinote2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Why? Because diversity by itself is not enough. Rather, it must be skillfully managed in an inclusive way. Without inclusion and equity, diversity has a high chance of becoming chaotic, leading to lower productivity and engagement, higher turnover, and even litigation.")]), _vm._v(" "), _c('p', {
    staticClass: "fimage"
  }, [_c('a', {
    attrs: {
      "id": "fig0_3"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('strong', [_vm._v("Figure 3.")]), _vm._v(" Impact of diversity on team performance. "), _c('em', [_vm._v("Source")]), _vm._v(": Joseph DiStefano and Martha Maznevski, “Creating Value with DiverseTeams in Global Management,”"), _c('em', [_vm._v("Organizational Dynamics")]), _vm._v(" 29, no. 1 (2000): 45–63.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is no wonder, then, that homogeneity is so attractive. It is relatively easy to manage a group of people with similar backgrounds and experiences. It is significantly more difficult to convince teams made up of individuals of varying differences to understand each other’s thought patterns and behaviors, and to value them at a deep and "), _c('span', {
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("personal level. But inclusive leaders who are skilled at navigating these differences, and whose organizational values back them up, are able to optimize their performance to the point that those differences become leveraged assets that lead to better performance.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interestingly, even when diverse teams are managed well, homogeneous teams still outperform diverse ones in the early stages because of the disruption and conflict that can result when different perspectives, experiences, backgrounds, thinking, and communication styles are merged. But over time, diverse teams managed well by inclusive leaders significantly outperform well-managed homogeneous ones (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_4"
    }
  }, [_vm._v("figure 4")]), _vm._v(").")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("WHAT DOES AN INCLUSIVE LEADER LOOK LIKE?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First, let us share how we determined what an inclusive leader looks like, thanks to the deep expertise and scientific knowledge of our PhD statisticians and industrial and organizational psychologists at the Korn Ferry Institute.")]), _vm._v(" "), _c('p', {
    staticClass: "fimage"
  }, [_c('a', {
    attrs: {
      "id": "fig0_4"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('strong', [_vm._v("Figure 4.")]), _vm._v(" Impact of diversity on team performance. "), _c('em', [_vm._v("Source")]), _vm._v(": Joseph DiStefano and Martha Maznevski, “Creating Value with Diverse Teams in Global Management,”"), _c('em', [_vm._v("Organizational Dynamics")]), _vm._v(" 29, no. 1 (2000): 45–63. Graph is adapted from three different sources: DiStefano and Maznevski, Katherine Phillips, and Bruce Tuckman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since 2015, we have assessed more than three thousand leaders on inclusive leadership. We began with working assumptions grounded in Korn Ferry’s vast knowledge and research on leadership, diversity, and inclusion. We tested our assumptions through fieldwork and "), _c('span', {
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("then through the rigorous analysis of data collected from thousands of leaders. Over time, our knowledge deepened and evolved into our Inclusive Leader model.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With this experiential and quantitative grounding we mapped out a clear, inclusive leader profile of competencies and traits, this time based on a thorough analysis of Korn Ferry’s database of more than 3 million leadership assessments. We then used a variety of additional qualitative testing strategies, which included an Inclusive Leader survey of talent professionals, in-depth interviews with inclusive leaders, focus groups in Argentina, Colombia, Germany, India, and the United States, and one virtual focus group with five participants from different African countries. This rich and diverse data provided us with profound insight into what it takes to be an inclusive leader. (See "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("appendix B")]), _vm._v(" for details on each of the research methodologies.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We determined that inclusive leadership can be defined empirically and experientially by looking at specific inclusive leader competencies—what leaders do to be inclusive—and traits—who they are that leads to their being inclusive. Therefore, inclusive leadership can be assessed, coached, and developed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We define inclusive leaders as leaders who interact with the diversity around them, who build interpersonal trust, who take the views of others into account, and who are adaptive. These abilities increase their effectiveness and the impact they have on individuals, teams, clients, customers, and communities—and therefore on the organization as a whole.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("TRAITS—INNER ENABLERS OF INCLUSIVE LEADERSHIP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Traits are how we are wired. They indicate our personality characteristics, which heavily influence how we think, feel, and act. In the Inclusive Leader model, traits are the enablers that support the inclusive leader competencies. Taken as a whole, these traits help answer the following question: What is a leader’s natural disposition toward differences?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We found five trait clusters (authenticity, emotional resilience, self-assurance, inquisitiveness, and flexibility) that enable inclusive leadership, and each contains several subtraits:")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    attrs: {
      "aria-label": "10",
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Authenticity")]), _vm._v(" requires humility, setting aside ego, and establishing trust in the face of opposing beliefs, values, or perspectives.")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Emotional resilience")]), _vm._v(" requires the ability to remain composed in the face of adversity and difficulty, including when one is around others with differences. It also requires situational awareness, to be able to pivot and change behaviors to effectively manage diversity.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Self-assurance")]), _vm._v(" requires a stance of confidence and optimism.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Inquisitiveness")]), _vm._v(" requires openness to differences, curiosity, and empathy.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Flexibility")]), _vm._v(" requires the ability to tolerate ambiguity and to be adaptable to diverse needs.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later, we will explore these enabling traits in more detail and look at why all of the listed traits are essential to leading inclusively, with skill and impact.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("COMPETENCIES—THE FIVE DISCIPLINES OF INCLUSIVE LEADERS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Traits such as an openness toward differences are must-haves, but they are not enough to make an inclusive leader. An inclusive leader must also possess the skills to lead inclusively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Korn Ferry found and used empirical analysis to organize these competencies into the clusters that we call the five disciplines. The inclusive leader builds interpersonal trust, integrates diverse perspectives, optimizes talent, applies an adaptive mindset, and achieves transformation.")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Builds interpersonal trust")]), _vm._v(". The inclusive leader embraces perspectives that differ from their own; they are honest and authentic.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Integrates diverse perspectives")]), _vm._v(". The inclusive leader considers all points of view and the needs of others and skillfully navigates conflict situations")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Optimizes talent")]), _vm._v(". The inclusive leader motivates others, supports their growth, and joins forces for collective success.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    attrs: {
      "aria-label": "11",
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Applies an adaptive mindset")]), _vm._v(". The inclusive leader takes a broad worldview, adapts behavior to suit the situation, and creates new approaches.")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" "), _c('strong', [_vm._v("Achieves transformation")]), _vm._v(". The inclusive leader confronts difficult topics and brings people along to achieve results.")])])]), _vm._v(" "), _c('p', {
    staticClass: "fimage"
  }, [_c('a', {
    attrs: {
      "id": "fig0_5"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('strong', [_vm._v("Figure 5.")]), _vm._v(" The Inclusive Leader model. "), _c('em', [_vm._v("Source")]), _vm._v(": Korn Ferry Institute, 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The five disciplines, based on competencies, are enabled by the five trait clusters. "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_5"
    }
  }, [_vm._v("Figure 5")]), _vm._v(" shows how these are related. Leaders can have expanding spheres of impact that flow from self, team, and organization. If we follow the Inclusive Leader model in "), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#fig0_5"
    }
  }, [_vm._v("figure 5")]), _vm._v(" clockwise, "), _c('span', {
    attrs: {
      "aria-label": "12",
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("the spheres of influence widen as one moves along the model. "), _c('em', [_vm._v("Builds interpersonal trust")]), _vm._v(" primarily involves the spheres of self and team, while "), _c('em', [_vm._v("integrates diverse perspectives")]), _vm._v(" moves more fully into the realm of impact on the team. "), _c('em', [_vm._v("Optimizes talent")]), _vm._v(" has a major impact on both the team and the organization, but both still primarily relate to the direct impact on talent. It’s in the last two disciplines, "), _c('em', [_vm._v("applies an adaptive mindset")]), _vm._v(" and "), _c('em', [_vm._v("achieves transformation")]), _vm._v(", where the impact lies heavily on the organization—not only on people strategies and experiences but also on other business imperatives, such as innovation, globalization, brand and reputation, and growing market share.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In "), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_vm._v("part 1")]), _vm._v(", we will devote full chapters to each of the five disciplines, complete with stories of how they were put into action and the results they yielded.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("BIOGRAPHY MATTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is a vital wrapper around our Five Disciplines model: biography. A leader’s formative and lived experiences create a unique, irreplicable story that in essence makes them “diverse”—though the term "), _c('em', [_vm._v("diverse")]), _vm._v(" is commonly misused. People often will refer to “diverse candidates” or “diverse talent” when they really are referring to talent that has been traditionally underrepresented. But these people are no more or less diverse than those from the majority culture. Diversity is about the full range of differences. Instead of talking about diverse employees, then, it is much better to talk about diverse workforces and teams. Every person is diverse in their own way, and it is useful to embrace this notion because it can be potently effective in helping those in the majority culture—in many cases the White male—to begin to feel included in the inclusion journey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In any event, because biography matters, it is important to recognize that each person’s “diversity” confers on them advantages or disadvantages that create inequity in society and the workplace. Addressing this disparity is what leads us to the work of inclusion and equity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have found that knowing clients’ biographies as well as their experience with diversity can help in how we coach them on the five disciplines. Experiences that expose one to a variety of geographies, to people with all kinds of differences and a range of contexts, can have a profound impact in challenging leaders’ assumptions and ways of doing "), _c('span', {
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("things. It also helps them realize the power of approaching problems by unconventional paths and to recognize that customer and employee needs cannot be effectively addressed the same way across the board. Instead, solutions may be varied and sometimes counterintuitive.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Formatively, a leader may have grown up in a different country or region from the one in which they live and work today. They may have experienced being in the minority, in the majority, or in a fully racially or ethnically mixed environment. Their parents may have done an overseas stint in business, nonprofit, government, military, or missionary organizations. While in school, leaders may have studied abroad or participated in a service program. They may have undertaken an extended stay in a different culture, whether within or outside of their native country. Their professional development might have included expatriate assignments. Work assignments across varied (cross-functional, cross-divisional, or cross-market) contexts also may have forced leaders to operate outside their comfort zones and to challenge their own assumptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In our Inclusive Leader survey of talent professionals, there was unanimous consensus that inclusive leaders must seek to gain new and diverse experiences in the present and the future. It also was seen as valuable if leaders had been actively involved in “giving back,” such as by sponsoring or mentoring people from different backgrounds (68%), or if they had worked in an organization with a meaningful amount of diversity (48%).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Biography matters because exposure to different experiences, coupled with deliberate development and discussion about what they mean, can be transformative. This can help leaders get comfortable seeing the world from other points of view. Inclusive leaders learn to more profoundly leverage their biographies, with savvy, to lead others inclusively. And for those who did not have early life exposures to diverse experiences, it’s not too late for short- or long-term immersion experiences, or even lifestyle changes. Throughout this book you will come across leaders who have done both.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("HOW THIS BOOK IS ORGANIZED")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the next section, “The Core of Inclusive Leadership,” we will explore the traits that enable leaders to develop and practice each of the five disciplines. These traits, which are made of strands of personal "), _c('span', {
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("beliefs, values, and personality, are leaders’ source of energy for building the full range of skills that the five disciplines require.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following that summary, "), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_vm._v("part 1")]), _vm._v(" focuses on each of the five disciplines of inclusive leaders, one chapter at a time, using quantitative and qualitative research to unpack each of the competencies that compose the disciplines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2")]), _vm._v(" focuses on the exemplars, the individuals and organizations that are standouts in living inclusive leadership. We tell these stories from the point of view of impact—how inclusive leadership led to business outcomes, how their actions and behavior with their diverse workforces helped them to optimize results.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(" lays out some of the most intractable diversity and inclusion challenges that inclusive leaders must confront to design the equitable organizations of the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And finally, in the conclusion, we zero in on the key takeaways from our journey together, and then leave the last word to the next generation of leaders among Millennials (born roughly between 1980 and 1994) and Generation Z (born between 1995 and 2015), in terms of what they understand inclusive leadership means for them and how that understanding will shape the further evolution of inclusive leadership.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is one other essential element to how we put this book together. We invited more than a dozen current or recent Korn Ferry consultants to write sidebars that illustrate various aspects of how the five disciplines and their enabling traits play out in reality. These contributors reflect diversity across geographies, abilities, religion, gender, race and ethnicity, generation, and areas of experience. We did this in the spirit of inclusive leadership, because of our deep-seated belief that the collective intelligence of a diverse team would yield greater value to the work and to your reading experience. The individuals they choose to focus on—organizational executives, historical figures, artists, athletes, or public servants—as well as their interpretation of how these individuals lead inclusively, is unique to them. We could not have come up with these sidebars on our own. Not only did each contributor add richness at face value with their bylined sidebar, but also their contributions further the synthesis of our thinking about what it takes to be an inclusive leader.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So here we are, with the case for inclusive leadership laid out and an introduction to a verified model for what this kind of leadership looks like. Ready to dive in?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "15",
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("It takes a comprehensive plan to foster inclusive leadership that achieves the promises of a more diverse workforce. We invite you to dig deeper into what it means to be an inclusive leader and to learn from those who have started to crack the code.")])]), _vm._v(" "), _c('p', {
    staticClass: "centerg"
  }, [_vm._v("■   ■   ■"), _c('span', {
    attrs: {
      "aria-label": "16",
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 75
// module chunks = 0